import DeliveryShiftStartComponent from "@/components/delivery/DeliveryShiftStart";

export default function DeliveryShiftStartPage() {
  return <DeliveryShiftStartComponent />;
}
